
        var result = require("!!../../../../node_modules/css-loader/index.js!./event.component.css");

        if (typeof result === "string") {
            module.exports = result;
        } else {
            module.exports = result.toString();
        }
    


//////////////////
// WEBPACK FOOTER
// ./app/components/event/event.component.css
// module id = 1415
// module chunks = 0